import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const AllAttendees = lazy(() => import("@/pages/admin/ConferenceArchive/AllAttendees/AllAttendees"));
const Invoices = lazy(() => import("@/pages/admin/ConferenceArchive/Invoices/Invoices"));
const InvoiceDetail = lazy(() => import("@/pages/admin/ConferenceArchive/Invoices/InvoiceDetail/InvoiceDetail"));

const Error404 = lazy(() => import("@/pages/Error404"));

const conferenceArchiveRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "attendees",
    children: [
      {
        index: true,
        element: <AllAttendees />,
      },
    ],
  },
  {
    path: "invoices",
    children: [
      {
        index: true,
        element: <Invoices />,
      },
      {
        path: ":id",
        element: <InvoiceDetail />,
      },
    ],
  },
];

export default conferenceArchiveRoutes;
